/* eslint-disable */
import { Component, Injector } from '@angular/core';
import { BaseRoute } from '../../../shared/components/base.route';

@Component({
  selector: 'ns-fund-by-broker-review',
  template: require('./fund-by-broker-review.component.html')
})

export class FundByBrokerReviewComponent extends BaseRoute {
  constructor(injector: Injector) {
    super(injector);
  }

  ngOnInit() {
    this.unlistedBroker = this.flowManager.isUnlistedBroker;
    this.acatsInvestAccount = this.appActions.getData('DepositFunds.to');
    this.acatsFirmName = this.appActions.getData('Acats.acatsFirmName');
    this.acatsFirmDTC = this.appActions.getData('Acats.acatsFirmDTC');
    this.acatsFirmAccount = this.appActions.getData('Acats.acatsFirmAccount');
    this.acatsAmount = this.appActions.getData('Acats.acatsAmount');
    this.acatsAmountDisplay = (this.acatsAmount === 'PARTIAL_TRANSFER') ? 'Partial' : 'Full';
    this.submitError = null;
    this.isMP = this.flowManager.getAppType() === 'tka';
  }

  difFundingMethod(event) {
    this.modal.difFunding();
  }

  submitAcatsRequest() {
    this.submitError = null;
    this.form.buttons.inputs.next.classes += ' spinner';
    this.form.buttons.inputs.back.classes += ' disabled';
    this.disableButtons(true);
    const payload = {
      acatsInvestAccount: this.acatsInvestAccount,
      acatsFirmName: this.acatsFirmName,
      acatsFirmAccount: this.acatsFirmAccount,
      acatsFirmDTC: this.acatsFirmDTC
    }

    this.appProxy.submitAcats(payload, resp => {
      if (resp.status === 200 && resp.result.requestId) {
        this.appActions.setData('Acats.acatsRequestId',resp.result.requestId);
        this.appActions.setData('Acats.acatsUnlistedBroker',this.flowManager.isUnlistedBroker);
        this.router.navigate(['/fund-by-broker-receipt']);
      } else {
        this.form.buttons.inputs.next.classes = 'btn mobile-primary';
        this.form.buttons.inputs.back.classes = 'btn-secondary';
        this.disableButtons(false);
        this.submitError = resp.message;
      }
    });
  }

  disableButtons(bool) {
    this.form.buttons.inputs.next.disabled = bool;
    this.form.buttons.inputs.back.disabled = bool;
  }

  btnClick(e) {
    if (e.action === 'back') {
      if (this.unlistedBroker === true) {
        this.router.navigate(['/fund-by-broker-info']);
      } else {
        this.router.navigate(['/fund-by-broker-account']);
      }
    } else if (e.action === 'next'){
      this.submitAcatsRequest();
    } else if (e.action === 'fund_later') {
      this.flowManager.fundLaterRouting();
    }
  }
}
